import { Link } from "react-router-dom";

export const EducationalDisclaimer = ({ className = "" }) => (
  <p className={`text-xs text-[#838F80] text-center leading-relaxed ${className}`} data-testid="educational-disclaimer">
    For educational purposes only. Not medical advice. Always consult your healthcare provider before making changes.{" "}
    <Link to="/disclaimer" className="text-[#2D6A4F] hover:underline">
      Full disclaimer
    </Link>.
  </p>
);

export const LegalAgreement = ({ className = "" }) => (
  <p className={`text-xs text-center text-[#838F80] leading-relaxed ${className}`} data-testid="legal-agreement">
    By purchasing, you agree to our{" "}
    <Link to="/terms" className="text-[#2D6A4F] hover:underline">Terms</Link>,{" "}
    <Link to="/privacy" className="text-[#2D6A4F] hover:underline">Privacy Policy</Link>,{" "}
    <Link to="/refund" className="text-[#2D6A4F] hover:underline">Refund Policy</Link>, and{" "}
    <Link to="/disclaimer" className="text-[#2D6A4F] hover:underline">Medical Disclaimer</Link>.
    Individual results vary. These are educational resources, not medical treatments.
  </p>
);

export default EducationalDisclaimer;
